module.exports = __webpack_public_path__ + "media/images/captive_portal/Stage-54056b19e7878a753b93e12031925451.svg";